<template>
  <page>
    <div class="page-title">提款管理</div>
    <div class="page-content" style="padding: 0">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="提款中" name="pending">
          <WithdrawPendingTab @update="handleUpdate"></WithdrawPendingTab>
        </el-tab-pane>
        <el-tab-pane label="历史记录" name="history">
          <WithdrawHistoryTab @update="handleUpdate"></WithdrawHistoryTab>
        </el-tab-pane>
      </el-tabs>
    </div>
  </page>
</template>

<script>
// 引入标签页组件
import WithdrawHistoryTab from './components/ManageWithdrawHistoryTab.vue'
import WithdrawPendingTab from './components/ManageWithdrawPendingTab.vue'

export default {
  name: 'AdminFinanceWithdrawManage',
  components: {
    WithdrawPendingTab,
    WithdrawHistoryTab,
  },
  data() {
    return {
      // 当前激活的标签页
      activeTab: 'pending',
    }
  },
  methods: {
    // 处理子组件更新事件
    handleUpdate() {
      this.$message.info('数据已更新')
    },
  },
}
</script>

<style scoped>
.page-content {
  padding: 0;
}
.page-content :deep(.el-tabs__item) {
  padding: 0 20px !important;
}
</style>
